import apiClient from '../apiClient';
import { GET_AREA_BY_CITY_URL } from '../apiUrl';

const getAreaByCityApi = Id => {
  return apiClient.get(GET_AREA_BY_CITY_URL(Id));
};

export default getAreaByCityApi;
